import React from "react";

export function Section(props) {
    return (
        <div
            id={props.id ? props.id : ""}
            className={`flex justify-start 2xl:justify-center px-16 py-12 md:p-24 md:px-32 ${
                props.className ? props.className : ""
            }`}
        >
            <div className="flex 2xl:max-w-screen-lg grow">
                <div className="flex flex-col flex-start">
                    <div className="">{props.children}</div>
                </div>
            </div>
        </div>
    );
}
